import 'css-chunksrc/client/common/tagList/tag/styles.scss';export default {
  "tag": "_tag_jrx02_1",
  "icon": "_icon_jrx02_26",
  "removeTagIconContainer": "_removeTagIconContainer_jrx02_38"
};